export const SearchBarStyles = {
    container: "w-full flex justify-center items-center bg-iw-background shadow-iw sm:w-full rounded-md m-2 gradient-outline-input",
    icon: "m-5",
    input: "py-6 w-11/12 flex text-iw-searchTitle focus:outline-none overflow-ellipsis mr-10 text-[14px] leading-[20px] font-medium",
    clearIcon: "m-5"
};
